import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f8aaab0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-row tw-gap-[20px] tw-items-center" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-flex-1" }
const _hoisted_3 = { class: "tw-mb-[13px] tw-flex tw-items-center" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = {
  key: 0,
  class: "vendor-ass-card-status-tag"
}
const _hoisted_6 = { class: "tw-flex tw-justify-between tw-items-center tw-mb-[6px] tw-w-full" }
const _hoisted_7 = { class: "card-field" }
const _hoisted_8 = { class: "tw-text-[#B7B7B7] tw-text-[13px] tw-font-[500]" }
const _hoisted_9 = { class: "tw-flex tw-justify-between tw-items-center tw-w-full" }
const _hoisted_10 = { class: "card-field" }
const _hoisted_11 = { class: "tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400] tw-not-italic tw-leading-[130%]" }
const _hoisted_12 = { class: "vendor-ass-chart tw-h-[72px] tw-w-[72px]" }

import { IChecklistRequested } from "@/interfaces/vendor";
import { checklistRequestedStatusId } from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import dayjs from "dayjs";
import { PropType, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboardVendorAssessmentCard',
  props: {
  classStyleContent: {
    type: String,
    default: "",
  },
  data: { type: Object as PropType<IChecklistRequested>, required: true },
},
  setup(__props) {

const props = __props;


const isLoading = computed(() => {
  return !props.data.checklistRequestedId;
});

const percentFormat = Number((props.data.scorePcnt * 100).toFixed(0));

const convertColor = () => {
  if (percentFormat >= 75) return "#01893D";
  if (percentFormat < 75 && percentFormat >= 50) return "#48A0FF";
  if (percentFormat >= 40 && percentFormat < 50) return "#FE9A05";
  if (percentFormat < 40) return "#F7553C";
};
const optionsCurrent = computed(() => ({
  colors: [convertColor()],
  chart: {
    height: 72,
    type: "radialBar",
  },
  plotOptions: {
    radialBar: {
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          show: true,
          color: convertColor(),
          fontSize: "13px",
          fontWeight: 600,
          fontFamily: "Poppins",
          offsetY: 5,
          offsetX: 3,
          formatter: () => `${percentFormat}%`,
        },
      },
    },
  },
  stroke: {
    show: true,
    lineCap: "round",
  },
  fill: {
    opacity: 1,
  },
  labels: ["current"],
}));

const checkStatusId = () => {
  if (
    props.data.statusId === checklistRequestedStatusId.created ||
    props.data.statusId === checklistRequestedStatusId.inProgress ||
    props.data.statusId === checklistRequestedStatusId.waiting ||
    props.data.statusId === checklistRequestedStatusId.submitted
  )
    return true;
};

const handleCountAssessmentCompleted = () => {
  const checklistRequestedCompleted =
    props.data.checklistRequestedHistory?.filter(
      (item) => item.statusId === checklistRequestedStatusId.completed,
    );
  return checklistRequestedCompleted?.length;
};

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    id: `dashboard-vendor-ass-card`,
    class: _normalizeClass([
      'tw-bg-[#FCFCFC] tw-flex tw-flex-col tw-justify-between tw-p-[20px]  dashboard-vendor-ass-card',
      __props.classStyleContent,
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(__props.data.providerName), 1),
          (checkStatusId())
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)("app-dashboard-vendor-assessment-card-tag-1")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
                "app-dashboard-vendor-assessment-card-assessments-1",
              )), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(handleCountAssessmentCompleted()), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getComponentUiText)(
                "app-dashboard-vendor-assessment-card-last-assessment-1",
              )), 1),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(dayjs)(__props.data.dateUpdated ?? __props.data.dateAdded).format("DD MMM YYYY")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_apexchart, {
          class: "score-chart-short",
          type: "radialBar",
          width: "160",
          options: optionsCurrent.value,
          series: [_unref(percentFormat)]
        }, null, 8, ["options", "series"])
      ])
    ])
  ], 2))
}
}

})